import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import AdditionalSurChargesOrCharges from "./AdditionalSurChargesOrCharges"

export default () => {//this shows moving charges of the estimate
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    let Record = useContext(RecordsManagementContext)
    return (
        IV1_PageDetails.DigitalInvoicePagePricingData ?
        <>
            <div className="col">
                <table border="2" cellPadding="5" cellSpacing="10" className="charges_table">
                    <tbody>
                    {
                        IV1_PageDetails.DigitalInvoicePagePricingData.OverTimePrice > 0 && IV1_PageDetails.DigitalInvoicePagePricingData.showOvertimeFields === true  ?
                            <MovingChargesType type={"OVERTIME FEE"}
                                               placeHolder={IV1_PageDetails.DigitalInvoicePagePricingData.OverTimeHours}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.DigitalInvoicePagePricingData.OverTimePrice} />
                            :
                            <></>
                    }
                    {
                        IV1_PageDetails.DigitalInvoicePagePricingData.TravellingHours ?
                            <MovingChargesType type={IV1_PageDetails.DigitalInvoicePagePricingData.TravelTime}
                                               placeHolder={IV1_PageDetails.DigitalInvoicePagePricingData.showTravelHours === false ? 0 : IV1_PageDetails.DigitalInvoicePagePricingData.TravellingHours}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.DigitalInvoicePagePricingData.TravelPrice} />
                            :
                            <></>
                    }
                    {
                        IV1_PageDetails.BaseFee ?
                            <MovingChargesType type={IV1_PageDetails.BaseFee}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.BasePrice} />
                            :
                            <></>

                    }
                    {
                        IV1_PageDetails.FuelSurCharge ?
                            <MovingChargesType type={IV1_PageDetails.FuelSurCharge}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.FuelPrice} />
                            :
                            <></>

                    }
                    {
                        IV1_PageDetails.PackingMaterialPrice ?
                            <MovingChargesType type={IV1_PageDetails.PackingMaterial}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.PackingMaterialPrice} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.PackingFee ?
                            <MovingChargesType type={IV1_PageDetails.PackFee}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.PackingFee} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.WarehouseHandling ?
                            <MovingChargesType type={"WAREHOUSE HANDLING"}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.WarehouseHandling} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.StorageFee ?
                            <MovingChargesType type={IV1_PageDetails.StorageService}
                                               currency={IV1_PageDetails.Currency}
                                               price={(IV1_PageDetails.StorageFee)} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.DiscountPrice && IV1_PageDetails.addDiscountToSubtotal == "" ?
                            <MovingChargesType type={"DISCOUNT"}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.DiscountPrice} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.AdditionalSurCharges ?
                            IV1_PageDetails.AdditionalSurCharges.map((sur_charge,key) =>{
                                return(
                                    sur_charge.Show ==="true" ?
                                        <AdditionalSurChargesOrCharges key={key + "surChargeName"}
                                                                       name={sur_charge.Name} currency={IV1_PageDetails.Currency}
                                                                       price={sur_charge.Value}/>
                                        :
                                        <tr key={key + "surChargeName"}></tr>
                                )
                            })
                            :
                            <></>

                    }

                    {
                        IV1_PageDetails.AdditionalChargesSubTotal ?
                            IV1_PageDetails.AdditionalChargesSubTotal.map((charge,key) =>{
                                return(
                                    charge.Show  ?
                                        <AdditionalSurChargesOrCharges key={key + "chargeNameRecord"}
                                                                       name={charge.Name} currency={IV1_PageDetails.Currency}
                                                                       price={charge.Value}/>
                                        :
                                        <tr key={key + "chargeNameRecord"}></tr>
                                )
                            })
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.DiscountPrice && IV1_PageDetails.addDiscountToSubtotal != "" && IV1_PageDetails.addDiscountToSubtotal ?
                            <MovingChargesType type={"DISCOUNT"}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.DiscountPrice} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.SubTotal ?
                            <MovingChargesType type={"SUBTOTAL"}  currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.SubTotal} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.AdditionalCharges ?
                            IV1_PageDetails.AdditionalCharges.map((charge,key) =>{
                                return(
                                    charge.Show  ?
                                        <AdditionalSurChargesOrCharges key={key + "chargeNameRecord"}
                                                                       name={charge.Name} currency={IV1_PageDetails.Currency}
                                                                       price={charge.Value}/>
                                        :
                                        <tr key={key + "chargeNameRecord"}></tr>
                                )
                            })
                            :
                            <></>

                    }

                    {
                        IV1_PageDetails.DiscountPrice && IV1_PageDetails.addDiscountToSubtotal != "" && !(IV1_PageDetails.addDiscountToSubtotal) ?
                            <MovingChargesType type={"DISCOUNT"}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.DiscountPrice} />
                            :
                            <></>
                    }

                    {
                        IV1_PageDetails.PriceCheckListAdditionalCharges ?
                            <MovingChargesType type=  { `${IV1_PageDetails.PriceCheckListAdditionalCharges.Text } %
                               ${IV1_PageDetails.PriceCheckListAdditionalCharges.Name}`}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.PriceCheckListAdditionalCharges.SurCharge} />
                            :
                            <></>

                    }
                    {
                        IV1_PageDetails.PriceCheckListAutomaticValuation ?
                            <MovingChargesType type={IV1_PageDetails.PriceCheckListAutomaticValuation.AutomaticValuation}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.PriceCheckListAutomaticValuation.Price} />
                            :
                            <></>
                    }
                    {
                        Record.TipValue != '' ? <MovingChargesType type={"TIP"}  currency={IV1_PageDetails.Currency}
                                                                   price={Record.TipValue} /> :
                        IV1_PageDetails.Tip ?
                            <MovingChargesType type={"TIP"}  currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.Tip} /> :
                            <></>
                    }
                    {
                        IV1_PageDetails.ProcessingFee ?
                            <MovingChargesType type={IV1_PageDetails.ProcessingFee.Text}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.ProcessingFee.Amount} />
                            :
                            <></>
                    }
                    {
                        IV1_PageDetails.GrandTotal ?
                            <MovingChargesType type={IV1_PageDetails.GrandTotal.Text}
                                               currency={IV1_PageDetails.Currency}
                                               price={Record.NewTotalCost.toString() != '' ? Record.NewTotalCost.toString() : IV1_PageDetails.GrandTotal.Cost} />
                            :
                            <></>

                    }
                    {
                        IV1_PageDetails.NotToExceedTotal ?
                            <MovingChargesType type={IV1_PageDetails.NotToExceedTotal.Text}
                                               currency={IV1_PageDetails.Currency}
                                               price={IV1_PageDetails.NotToExceedTotal.Cost} />
                            :
                            <></>

                    }
                    <MovingChargesType type={"PAYMENT"}
                                       currency={IV1_PageDetails.Currency}
                                       price={IV1_PageDetails.Payment} />

                    <MovingChargesType type={"BALANCE DUE"}
                                       currency={IV1_PageDetails.Currency}
                                       price={Record.NewBalanceDue.toString() != '' ? Record.NewBalanceDue.toString() : IV1_PageDetails.BalanceDue} />
                    </tbody>
                </table>
            </div>
        </>
            : <></>
    )
}

const MovingChargesType = (props) =>{
    return(
        <tr>
            <td className="table_text">
                {props.placeHolder ?
                    <input type="text" className="form-control input_design"
                           placeholder={props.placeHolder}
                           disabled />:
                    <></>
                }
                {props.type}</td>
            <td>
                <MovingChargesDetails movingChargeCurrency = {props.currency}
                                      movingPrice = {props.price}/>
            </td>
        </tr>
    )
}

const MovingChargesDetails = (props) => {
    return(
        <div className="col-auto">
            <div className="input-group mb-2">
                <div className="input-group-prepend">
                    <div className="input-group-text">{props.movingChargeCurrency}</div>
                </div>
                <input type="text" className="form-control input_design_2"
                       id="inlineFormInputGroup" placeholder={props.movingPrice} disabled/>
            </div>
        </div>
    )
}